var React = require('react');

function Geometric (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M96.3 875L500 125l403.7 750H96.3z"}));
}

Geometric.defaultProps = {"viewBox":"0 0 1000 1000"};

module.exports = Geometric;

Geometric.default = Geometric;
